import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, ValidatorFn } from '@angular/forms';
import { AccionesRntEntry } from 'src/app/shared/entrys/acciones-rnt.entry';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { MunicipioEntry } from 'src/app/shared/entrys/municipio.entry';
import { DepartamentoEntry } from 'src/app/shared/entrys/departamento.entry';
import { ReportesCertificadoService } from '../certificados/reportes-certificados.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BasicasLoVService } from 'src/app/shared/services/basicas-lov.service';
import { CampoAdicionalCategoriaService } from '../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service';
import { ReportesEstablecimientosService } from '../establecimientos/reportes-establecimientos.service';
import { AccionRntService } from '../../configuracion/accion-rnt/accion-rnt.service';
import { ModuloAyudaService } from '../../configuracion/modulo-ayuda/modulo-ayuda.service';
import { HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { CertificadoEntry } from 'src/app/shared/entrys/certificado.entry';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ReporteGeneralService } from './reporte-general.service';
import { TipoSolicitudEntry } from 'src/app/shared/entrys/tipo-solicitud.entry';
import { EstadoSolicitudEntry } from 'src/app/shared/entrys/estado-solicitud.entry';



@Component({
  selector: 'app-reporte-general',
  templateUrl: './reporte-general.component.html',
  styleUrls: ['./reporte-general.component.scss']
})
export class ReporteGeneralComponent implements OnInit {
  dataTabla: DatoPaginadoModel;

  	fecha_inicio_inscripcion: any;
	fecha_inicio_renovacion: any;
	fecha_inicio_radicacion: any;
	fecha_inicio_ultima_actualizacion: any;

	
	
	paginaActual: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	prestador = RolesUsuario.Prestador;
	adminCC = RolesUsuario.AdministradorCC;
	columnas: Array<any> = [];
	columnasEnvio: any;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;
	isExportar = true;
	OcultarCampos = true;
	camaraComercio: string;
	// selects
	categoria: Array<any> = [];
	subcategoria: Array<any> = [];
	estadoRnt: Array<any> = [];
	tipoRNT: Array<any> = [];
  	departamento: Array<DepartamentoEntry> = [];
  	municipio: Array<MunicipioEntry> = [];
  	headerTabla: Array<string>;
	estadoSolicitudLista: Array<EstadoSolicitudEntry> = [];
	camarasLista: Array<CamaraComercioEntry>= [];
	tipoSolicitudLista: Array<TipoSolicitudEntry> = [];
	isSelect: boolean;
	camaraUser:string=null;
	exportarForm: FormGroup;
	codigoCamara:string="";
	tiposUsuario=[
		{id:1,descripcion:'Comerciante'},
		{id:2,descripcion:'No Comerciante'},
	];
	exportarList = [
		{ id: 'Descripcion_Camara', name: 'Cámara de Comercio' },
		{ id: 'Razon_Social', name: 'Razón social Establecimiento' },
		{ id: 'Numero_Identificacion', name: 'Número identificación' },
		{ id: 'Tipo_Usuario', name: 'Tipo Usuario' },
		{ id: 'Matricula', name: 'Matricula' },
		{ id: 'Fecha_Renovacion_Matricula', name: 'Fecha Renovación Matrícula' },
		{ id: 'Fecha_Matricula', name: 'Fecha Matrícula' },
		{ id: 'Numero_Rnt', name: 'Número Rnt' },
		{ id: 'Tipo_Rnt', name: 'Tipo Rnt' },
		{ id: 'Descripcion_Categoria', name: 'Categoria' },
		{ id: 'Descripcion_Subcategoria', name: 'Subcategoria' },
		{ id: 'Estado_Rnt', name: 'Estado Rnt' },
		{ id: 'Fecha_Inscripcion', name: 'Fecha Inscripción' },
		{ id: 'Fecha_Ultima_Renovacion', name: 'Fecha Última Renovación' },
		{ id: 'Ultimo_Anio_Renovado', name: 'Último Año Renovado' },


		{ id: 'Descripcion_Departamento', name: 'Departamento' },
		{ id: 'Descripcion_Municipio', name: 'Municipio' },
		{id:'Numero_Identificacion_Representante_Legal',name:'Identificación RL'},
		{id:'Nombre_Representante_Legal',name:'Nombre RL'},
		{id:'Correo_Electronico',name:'Correo Electrónico 1'},
		{id:'Correo_Electronico_Reportado',name:'Correo electrónico 2'},
		{id:'Direccion_Comercial',name:'Dirección comercial'},
		{id:'Descripcion_Departamento_Notificacion',name:'Departamento notificación'},
		{id:'Descripcion_Municipio_Notificacion',name:'Municipio notificación'},


		
		{ id: 'Direccion_Notificacion', name: 'Dirección notificación' },
		{ id: 'Telefono_Reportado_1', name: 'Teléfono 1' },
		{ id: 'Telefono_Reportado_2', name: 'Teléfono 2' },
		{ id: 'Usuario_Funcionario', name: 'Funcionario' },
		{ id: 'Numero_Radicacion', name: 'Número Radicado' },
		{ id: 'Tipo_Solicitud', name: 'Tipo de solicitud' },
		{ id: 'Estado_Solicitud', name: 'Estado de solicitud' },
		{ id: 'Fecha_Radicacion', name: 'Fecha de Radicación' },
		{ id: 'Fecha_Ultima_Actualizacion', name: 'Fecha de última actualización' },
		{ id: 'Numero_Empleados', name: 'Número de empleados' },
		{ id: 'Actividades_Economicas', name : 'Código Actividad Económica'},
		{ id: 'Actividades_Economicas_Descripcion', name : 'Actividad Económica'},
		{ id: 'Nombre_Operador_Alojamiento', name: 'Nombre del operador del alojamiento (cadena hotelera, entre otros)' },
		{ id: 'Cantidad_Habitaciones', name: 'Número total de unidades de alojamiento' },
		{ id: 'Cantidad_Camas', name: 'Número de camas o plazas' },
		{ id: 'Numero_Matricula_Embarcacion', name: 'N° Matricula de Embarcación' },
		{ id: 'Numero_Resolucion_Mintransporte', name: 'Numero resolución mintransporte' },
		{ id: 'Fecha_Resolucion_Mintransporte', name: 'Fecha resolución mintransporte' },
		{ id: 'Tarjeta_Profesional_Guia', name: 'Tarjeta profesional' },
		{ id: 'Numero_Identificacion_Depositario', name: 'Numero Identificación Depositario' },
		{ id: 'Nombre_Depositario', name: 'Nombre Depositario' },
		{ id: 'Correo_Electronico_Depositario', name: 'Correo Electrónico Depositario' },
		{ id: 'Nombre_Comercial', name: 'Nombre Comercial de la Plataforma' },
		{ id: 'Url', name: 'Url' },
		{ id: 'Nit_Arrendatario', name: 'Nit arrendatario' },
		{ id: 'Razon_Social_Arrendatario', name: 'Razón social arrendatario' },
		{ id: 'Correo_Electronico_Arrendatario', name: 'Correo electrónico arrendatario' },
		{ id: 'Numero_Telefonico_Arrendatario', name: 'Número telefónico arrendatario' },
	];

  constructor(private formBuilder: FormBuilder,
				private establecimientoComercioService: EstablecimientoComercioService, 
				public authService: AuthService,
				private categoriaService: CampoAdicionalCategoriaService, 
				private basicasLoVService: BasicasLoVService,
				private reportesEstablecimientos: ReportesEstablecimientosService,
				private ReporteGeneralService: ReporteGeneralService,
				private estadoRntService: AccionRntService, 
				private tipoRntService: ModuloAyudaService) { 
			this.createPagingTable();
			this.initForm();
			const selectAllControl = new FormControl(false);
			const formControl = this.exportarList.map(control => new FormControl(false));
			this.exportarForm = this.formBuilder.group({
				exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
				selectAll: selectAllControl
			});
      		this.paginaActual = 1;	
    }
	
	ngOnInit(): void {
    this.titleTable();
	this.onCamaraSelect();
    this.onDepartamentosSelect();
	this.onCategoriaSelect();
	this.onEstadoRNTSelect();
	this.onTipoRNTSelect();
	this.onEstadoSolicitud();
	this.onTipoSolicitud();
	this.onChanges();	
  }

  initForm() {		 
		this.filtro = this.formBuilder.group({
			codigo_camara: [null],
			razon_social: [null],
			numero_identificacion: [null],
			tipo_usuario_id: [null],
			tipo_solicitud_id: [null],
			tipo_rnt_id: [null],
			codigo_rnt: [null],
			categoria_id: [null],
			sub_categoria_id: [null],
			estado_rnt: [null],
			ultimo_anio_renovado: [null],
			codigo_departamento: [null],
			municipio_id: [null],
			funcionario: [null],
			numero_Radicado: [null],
			estado_solicitud_id: [null],
			fecha_inscripcion: [null],
			fecha_renovacion: [null],
			fecha_radicacion: [null],
			fecha_ultima_actualizacion: [null],
			fecha_inscripcion_desde: [null],
			fecha_inscripcion_hasta: [null],
			fecha_renovacion_desde: [null],
			fecha_renovacion_hasta: [null],
			fecha_radicacion_desde: [null],
			fecha_radicacion_hasta: [null],
			fecha_ultima_actualizacion_desde: [null],
			fecha_ultima_actualizacion_hasta: [null]
		  });

	}
  createPagingTable() {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
	}
  onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarRnt(value);
	}

	filtrar() {
		this.paginaActual = 1;
		this.createPagingTable();
		this.onConsultarRnt(1);
	}
	onTipoSolicitud() {
		this.establecimientoComercioService
		  .getTipoSolicitud()
		  .subscribe((resultado) => {
			if (resultado) {
			  this.tipoSolicitudLista = resultado.data as Array<TipoSolicitudEntry>;
			}
		  });
	  }
  onConsultarRnt(page: number) {
		this.ReporteGeneralService.getDataTable({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}
  	limpiar() {
		this.filtro.reset();
		this.createPagingTable();
		this.titleTable();
		this.onCamaraSelect();
		this.onCategoriaSelect();
		this.onEstadoRNTSelect();
		this.onTipoRNTSelect();
	}
	onSubcategoriaSelect() {
		if (this.filtro.value.categoria_id == null) {
		  this.subcategoria = null;
		  this.filtro.get('sub_categoria_id').setValue(null);
		} else {
		  this.ReporteGeneralService.getSubCategoriaxCategoria(this.filtro.value.categoria_id)
			.subscribe(resultado => {
			  if (resultado.result) {
				this.subcategoria = resultado.data;
			  } else {
				this.subcategoria = null;
				this.filtro.get('sub_categoria_id').setValue(null);
			  }
			});
		}
	  }
	onEstadoSolicitud() {
		this.establecimientoComercioService
		  .getEstadosSolicitud()
		  .subscribe((resultado) => {
			if (resultado) {
			  this.estadoSolicitudLista = resultado.data as Array<EstadoSolicitudEntry>;
			}
		  });
	  }
	titleTable() {
		this.headerTabla = ['Cámara de comercio','Nombre o Razón social','Nit','Tipo Usuario (Comerciante o No Comerciante)','Número Matrícula','Fecha Matrícula',
							'Fecha Renovación Matrícula','Tipo RNT','Número RNT','Categoría','Subcategoría','Código Actividad Económica','Actividad Económica',
							'Estado RNT','Fecha inscripción','Fecha Renovación RNT','Ultimo año renovado','Departamento','Municipio','Identificación RL',
							'Nombre RL','Correo Electrónico 1','Correo electrónico 2','Dirección comercial','Departamento notificación','Municipio notificación',
							'Dirección notificación','Teléfono 1','Teléfono 2','Funcionario','Número Radicado','Tipo de solicitud','Estado de solicitud',
							'Fecha de Radicación','Fecha de última actualización','Número de empleados','Nombre del operador del alojamiento (cadena hotelera, entre otros)',
							'Número total de unidades de alojamiento','Número de camas o plazas','N° Matricula de Embarcación','Numero resolución mintransporte',
							'Fecha resolución mintransporte','Tarjeta profesional','Numero Identificación Depositario','Nombre Depositario','Correo Electrónico Depositario',
							'Nombre Comercial de la Plataforma','URL de la plataforma','Nit arrendatario','Razón social arrendatario','Correo electrónico arrendatario',
							'Número telefónico arrendatario'];

	}

	onChanges() {
		this.exportarForm.get('selectAll').valueChanges.subscribe(bool => {
			this.exportarForm
				.get('exportarList')
				.patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
		});
		this.exportarForm.get('exportarList').valueChanges.subscribe(val => {
			const allSelected = val.every(bool => bool);
			if (this.exportarForm.get('selecAll').value !== allSelected) {
				this.exportarForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}

	minSelectCheckbox(min = 1) {
		const validator: ValidatorFn = (formArray: FormArray) => {
			const totalSelected = formArray.controls.map(control => control.value)
				.reduce((prev, next) => next ? prev + next : prev, 0);

			return totalSelected >= min ? null : { required: true };
		};
		return validator;
	}

	submit() {
		const selectedPreferences = this.exportarForm.value.exportarList
			.map((checked, index) => checked ? this.exportarList[index].id : null)
			.filter(value => value !== null);
		let date = new Date();
		this.columnasEnvio = selectedPreferences.join();
		
		this.ReporteGeneralService.generarExportarCertificados({ ...this.filtro.value, columnas: this.columnasEnvio })
			.subscribe((resultado:HttpResponse<Blob>) => {
				this.saveAsExcelFile(resultado, `reporte_general${date.toLocaleDateString()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}.xlsx`);
			});
	}

	private saveAsExcelFile(data: any, fileName: string): void {
		FileSaver.saveAs(data, fileName);
	}

	
	
	  
	descargarCertificado(certificado_generado_id: number){
		/*
		this.reporteService
			.descargarCertificado({certificado_generado_id})
			.subscribe(response=>{
				this.downloadPDF(response.body.data.file_data,response.body.data.nombre);
			})
			*/
	}
	onCheckDateInscripcion(minDate: NgbDate) {
		this.fecha_inicio_inscripcion = { day: minDate.day, month: minDate.month, year: minDate.year };
	}
	onCheckDateRadicacion(minDate: NgbDate) {
		this.fecha_inicio_radicacion = { day: minDate.day, month: minDate.month, year: minDate.year };
	}
	onCheckDateRenovacion(minDate: NgbDate) {
		this.fecha_inicio_renovacion = { day: minDate.day, month: minDate.month, year: minDate.year };
	}
	onCheckDateUltimaActualizacion(minDate: NgbDate) {
		this.fecha_inicio_ultima_actualizacion = { day: minDate.day, month: minDate.month, year: minDate.year };
	}
	downloadPDF(pdf:string,name: string) {
		const linkSource = `${pdf}`;
		const downloadLink = document.createElement("a");
		const fileName = name;
		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	}
  //MAESTROS
  	onCategoriaSelect() {
		this.categoriaService.getCategoria().subscribe(resultado => {
			if (resultado.result) {
				this.categoria = resultado.data;
			}
		});
	}
  	onDepartamentosSelect() {
    if (this.filtro.value.codigo_camara == null) {
      this.basicasLoVService.getDepartamentos(null).subscribe((resultado) => {
        if (resultado.result) {
          this.departamento = resultado.data as Array<DepartamentoEntry>;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getDepartamento({ codigo_camara: this.filtro.value.codigo_camara })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.departamento = resultado.data as Array<DepartamentoEntry>;
            this.onMunicipioSelect();
          }
        });
    }
  	}
  	onMunicipioSelect() {
    // tslint:disable-next-line:triple-equals
    if (
      this.filtro.value.codigo_camara == null &&
      this.filtro.value.codigo_departamento == null
    ) {
      this.basicasLoVService.getMunicipios(null).subscribe((resultado) => {
        if (resultado.result) {
          this.municipio = resultado.data as Array<MunicipioEntry>;
        }
      });
    } else {
      // tslint:disable-next-line:max-line-length
      this.reportesEstablecimientos
        .getMunicipio({
          codigo_camara: this.filtro.value.codigo_camara,
          departamento_id: this.filtro.value.codigo_departamento,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.municipio = resultado.data as Array<MunicipioEntry>;
          }
        });
    }
  	}
	onEstadoRNTSelect() {
		this.estadoRntService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estadoRnt = resultado.data;
			}
		});
	}

	onTipoRNTSelect() {
		this.tipoRntService.getTipoRnt().subscribe(resultado => {
			if (resultado.result) {
				this.tipoRNT = resultado.data;
			}
		});
	}
  onCamaraSelect() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				
				if(this.authService.getTipoUser()!=="1"){						
					this.camaraUser=this.authService.getCamaraUser();
					let selectedCamara = resultado.data.find(option => option.codigo_camara === this.camaraUser);
					selectedCamara = selectedCamara as	Array<CamaraComercioEntry>;	
					this.camarasLista.push(selectedCamara); 
					this.codigoCamara=this.camaraUser
					
				}else{
					this.camarasLista = resultado.data as Array<CamaraComercioEntry>;					
				}
				if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
					this.filtro.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					this.camaraComercio = (this.camarasLista.find(x => x.codigo_camara ===
						this.authService.getCamaraUser()).desc_camara);
				}											
			}
		});
	}
}